<template>
  <div :class="classes"></div>
</template>

<script>
const prefixCls = "gy-divider";
export default {
  props: {
    type: {
      type: String,
      default: "vertical",
    },
  },
  computed: {
    classes() {
      return [`${prefixCls}`, `${prefixCls}-${this.type}`];
    },
  },
};
</script>

<style lang="less">
.gy-divider {
  &-vertical {
    position: relative;
    display: inline-block;
    height: 0.9em;
    width: 1px;
    background-color: #ffffff;
    vertical-align: middle;
    margin: 0 8px;
    top: -0.06em;
  }
}
</style>
